import React, { useState } from "react";
import recoverCredentialService from "../../services/recoverCredentialService";

interface RecoverCredentialModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RecoverCredentialModal: React.FC<RecoverCredentialModalProps> = ({
  isOpen,
  onClose,
}) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  if (!isOpen) return null;

  // Συνάρτηση για καθαρισμό και κλείσιμο του modal
  const handleClose = () => {
    setEmail("");
    setError(null);
    setMessage(null);
    onClose();
  };

  const handleRecoverySubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setMessage(null);
    setLoading(true);

    try {
      // 1. Κλήση του ξεχωριστού service
      const response = await recoverCredentialService.recoverCredentials({ 
        email: email.trim() 
      });

      // 2. Εμφάνιση του μηνύματος από το C# backend
      setMessage(response.message);
      setEmail(""); // Καθαρισμός του πεδίου input
    } catch (err: any) {
      setError(
        err.response?.data?.message ||
          "Παρουσιάστηκε σφάλμα κατά την αποστολή. Δοκιμάστε ξανά."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="w-full max-w-md bg-white p-6 sm:p-8 rounded-2xl shadow-2xl border border-gray-100 space-y-6 relative animate-in fade-in zoom-in duration-200">
        
        {/* Header & Close Button */}
        <div className="flex items-center justify-between">
          <h3 className="text-xl font-bold text-gray-900">
            Ανάκτηση Στοιχείων
          </h3>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 focus:outline-none p-1 rounded-lg"
          >
            ✕
          </button>
        </div>

        <p className="text-sm text-gray-500">
          Εισαγάγετε το email σας για να σας αποστείλουμε τον προσωρινό κωδικό πρόσβασης.
        </p>

        {error && (
          <div className="p-3 text-sm text-red-700 bg-red-50 rounded-xl border border-red-200">
            {error}
          </div>
        )}

        {message && (
          <div className="p-3 text-sm text-green-700 bg-green-50 rounded-xl border border-green-200">
            {message}
          </div>
        )}

        <form onSubmit={handleRecoverySubmit} className="space-y-4">
          <div>
            <label htmlFor="modal-email" className="block text-sm font-medium text-gray-700 mb-1">
              Email Επικοινωνίας
            </label>
            <input
              id="modal-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="π.χ. info@example.com"
              disabled={loading}
              className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 text-sm focus:bg-white focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all disabled:opacity-50"
            />
          </div>

          <div className="flex items-center gap-3 pt-2">
            <button
              type="button"
              onClick={handleClose}
              disabled={loading}
              className="w-1/2 py-3 px-4 bg-gray-100 text-gray-700 rounded-xl font-medium hover:bg-gray-200 transition-all disabled:opacity-50"
            >
              Κλείσιμο
            </button>
            <button
              type="submit"
              disabled={loading}
              className="w-1/2 py-3 px-4 bg-primary text-white rounded-xl font-medium shadow-md hover:bg-darkprimary transition-all disabled:opacity-60"
            >
              {loading ? "Αποστολή..." : "Αποστολή"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};